import React, { useEffect } from 'react';
import { X } from 'lucide-react';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
  footer?: React.ReactNode;
  maxWidth?: 'sm' | 'md' | 'lg' | 'xl' | '2xl';
}
export function Modal({
  isOpen,
  onClose,
  title,
  children,
  footer,
  maxWidth = 'md'
}: ModalProps) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);
  if (!isOpen) return null;
  const maxWidths = {
    sm: 'max-w-sm',
    md: 'max-w-md',
    lg: 'max-w-lg',
    xl: 'max-w-xl',
    '2xl': 'max-w-2xl'
  };
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm animate-in fade-in duration-200" data-id="element-373">
      <div className={`bg-white rounded-2xl shadow-xl w-full ${maxWidths[maxWidth]} max-h-[90vh] flex flex-col animate-in zoom-in-95 duration-200`} role="dialog" aria-modal="true" data-id="element-374">
        <div className="flex items-center justify-between p-6 border-b border-gray-100" data-id="element-375">
          <h2 className="text-xl font-bold text-text-primary" data-id="element-376">{title}</h2>
          <button onClick={onClose} className="p-2 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-full transition-colors" data-id="element-377">
            <X className="w-5 h-5" data-id="element-378" />
          </button>
        </div>

        <div className="p-6 overflow-y-auto flex-1" data-id="element-379">{children}</div>

        {footer && <div className="p-6 border-t border-gray-100 bg-gray-50 rounded-b-2xl" data-id="element-380">
            {footer}
          </div>}
      </div>
    </div>;
}